<div class="flight-leg">
  <div class="first-container">
    <div class="label-txt">{{'childNotice.flight' | translate | titlecase}}</div>
    <div class="info-txt">{{numFlight}}</div>
  </div>
  <div class="second-container">
    <div>
      <div class="info-txt">{{departureTime}}</div>
      <div class="label-txt">{{dapartureFlight}}</div>
    </div>
    <div class="margin-line"> <img src="assets/images/line_flight.svg" alt="line"></div>
    <div>
      <div class="info-txt">{{arrivalTime}}</div>
      <div class="label-txt">{{arrivalFlight}}</div>
    </div>
  </div>
  <div class="third-container">
    <div class="third-container-boarding">
      <div class="label-txt">{{truncateCopy('Boarding' | translate)}}</div>
      <div class="info-txt">{{boardingTime}}</div>
    </div>
    <div class="third-container-duration">
      <div style="width: 80px;" class="label-txt aling-item-duration">{{ 'flightInfo.Duration' | translate}}</div>
      <div class="info-txt aling-item-duration">{{flightDuration}}</div>
    </div>
  </div>
</div>
